export default {"src":"/_next/static/media/info-alert.ab26666e.svg","height":27,"width":27};